export const AVERAGE_RANGE_REQUIREMENTS: Record<'day' | 'week' | 'month', number> = {
  day: 1,
  week: 7,
  month: 30
};

export const MS_PER_DAY = 24 * 60 * 60 * 1000;

